import './style/index.less';
import MessageCenter from './MessageCenter';

export default MessageCenter;
